module.exports = __webpack_public_path__ + "img/info.05613aeb.svg";